<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Cheques cobrados no acreditados</h1>
                <div class="caption">
                    Muestra según fecha los cheques no acreditados, mostrando en rojo los vencidos no acreditados y
                    en azul los no vencidos no acreditados. Permite selección de periodo, empresa y tipo a mostrar.
                    Todos: Muestra cada cheque no acreditados en su fecha de vencimiento correspondiente.
                    Vencidos agrupados: Muestra el total ya vencido de manera agrupada.
                    Puede hacerse zoom arrastrando el cursor sobre el periodo elegido.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa" multiple></empresa-select>
                        <v-select
                                :items="tipos"
                                v-model="d.tipo"
                                label="Tipo Fecha"
                                item-text="desig"
                                item-value="id"
                                hide-details
                                required
                        ></v-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <table class="datatable table">
                    <tr>
                        <th class="text-xs-left">Positivo</th>
                        <td class="text-xs-right" v-if="t.positivo">{{ t.positivo.v }} ({{ t.positivo.porcent }}%)</td>
                    </tr>
                    <tr>
                        <th class="text-xs-left">Negativo</th>
                        <td class="text-xs-right" v-if="t.negativo">{{ t.negativo.v }} ({{ t.negativo.porcent }}%)</td>
                    </tr>
                    <tr>
                        <th class="text-xs-left">Diferencia</th>
                        <td class="text-xs-right" v-if="t.diferencia">{{ t.diferencia }}</td>
                    </tr>
                    <tr>
                        <th class="text-xs-left">Acumulado</th>
                        <td class="text-xs-right" v-if="t.acumulado">{{ t.acumulado }}</td>
                    </tr>
                </table>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: 'todos',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD')
                },
                t: {},
                tipos: [
                    {id: 'todos', desig: 'Todos'},
                    {id: 'agrupados', desig: 'Vencidos Agrupados'},
                ],
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x',
                        animation: true
                    },
                    title: {
                        text: 'CHEQUES COBRADOS NO ACREDITADOS'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>$ {point.y:,.2f}</b><br/>',
                        shared: false
                    },
                    xAxis: {
                        type: "datetime",
                        gridLineColor: '#C0C0C0',
                        gridLineWidth: 1,
                        title: {
                            text: 'Mes'
                        },
                        dateTimeLabelFormats: {
                            month: '%b.%Y',
                            year: '%Y'
                        },
                        plotLines: [
                            {
                                color: '#00ff04',
                                width: 2,
                                value: '',
                                label: {
                                    text: 'Fecha Actual'
                                }
                            }
                        ]
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: false,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            marker: {
                                lineWidth: 1
                            }
                        }
                    },
                    series: []
                },
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/chq-no-acred', this.d)
                    .then(r => {
                        if (r.type === 'error') {
                            this.loading = false;
                            return false
                        }
                        this.chartOptions.series = r.data.datos;
                        this.t = r.data.totales;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        err(r)
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/chq-no-acred.vue